<template>
  <v-chip class="text-center" :color="getOperationColor().backgroundColor">
    <span :style="getOperationColor()" class="text-no-wrap text-center">
      {{ getLocalizedOperationType(operationType) }}
    </span>
  </v-chip>
</template>

<script>
import Operation from '@/lib/operation'
import OperationTypeMixin from '@/components/mixins/operation-type-mixin'

export default {
  name: 'OperationTypeIndicatorComponent',
  mixins: [OperationTypeMixin],
  props: {
    operationType: {
      type: String,
      required: true,
    },
    displayBorder: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    getOperationColor() {
      return Operation.getColor(this.operationType)
    },
    getClass() {
      if (this.displayBorder) {
        return 'm-0 p-1'
      }
      return 'm-0 p-3'
    },
  },
}
</script>

<style scoped></style>
